// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"uE-z","smallCardRow":"vE-z","largeCardRow":"wE-z","productSearchRow":"xE-z","curatedRow":"yE-z"};